export default __webpack_public_path__ + "static/media/UTPL_June_2024.0ac8fcde.pdf";